import React, { useEffect, useRef, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import Markup from "./../../../images/markup.png"
import "./ImageCropper.css";

const ImageCropper = ({ cancel, src, save, chooseImage, deleteImage, imageLoader, setImageLoader, setImage, createSnackbar }) => {

  const cropperArea = useRef();
  const cropper = useRef();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [cropperSize, setCropperSize] = useState({
    width: "",
    height: ""
  })

  useEffect(() => {
    setCropperSize({
      width: "",
      height: ""
    });

    const cropperAreaWidth = cropperArea.current.offsetWidth;
    const cropperAreaHeight = cropperArea.current.offsetHeight;

    let newImage = new Image();
    newImage.src = src;

    newImage.onload = function () {
      let coef = 0.0;
      const imageWidth = this.width;
      const imageHeight = this.height;

      if (imageWidth > imageHeight) {
        coef = cropperAreaWidth / imageWidth;
      } else {
        coef = cropperAreaHeight / imageHeight;
      }

      if (coef * imageHeight > cropperAreaHeight) {
        coef = cropperAreaHeight / imageHeight;
      }

      setCropperSize({
        width: `${coef * imageWidth}`,
        height: `${coef * imageHeight}`
      });
    }

    newImage.onerror = () => {
      setImage("");
      setImageLoader(false);
      createSnackbar.error("Invalid file");
    }
  }, [src]);

  const handleSave = () => {
    setSaveButtonLoading(true);
    const imageElement = cropper.current;
    if (!imageElement) return;
    const imageCropper = imageElement.cropper;
    if (!imageCropper.getCroppedCanvas()) return;
    save(imageCropper.getCroppedCanvas().toDataURL("image/jpeg"));
  }

  const handleImageLoad = () => {
    setImageLoader(false);
  }

  return (
    <>
      <div className="image-cropper">
        <div className='image-cropper__area' ref={cropperArea}>
          {
            cropperSize.width !== "" &&
            <Cropper
              className="image-cropper__cropper"
              style={{
                width: `${cropperSize.width}px`,
                height: `${cropperSize.height}px`
              }}
              src={src}
              aspectRatio={37.6 / 36.4}
              guides={true}
              background={false}
              zoomable={false}
              responsive={true}
              movable={false}
              rotatable={false}
              scalable={false}
              restore={false}
              minContainerHeight={cropperSize.height}
              minContainerWidth={cropperSize.width}
              minCanvasHeight={cropperSize.height}
              minCanvasWidth={cropperSize.width}
              preview=".image-cropper__review__target"
              ref={cropper}
              ready={handleImageLoad}
            />
          }
        </div>
        <div className="image-cropper__review">
          <div className="image-cropper__review__markup">
            <img src={Markup} alt="" />
          </div>
          <div className="image-cropper__review__target"></div>
        </div>
        <div className={imageLoader ? "image-cropper__loader visible" : "image-cropper__loader"}>
          <CircularProgress color='info' />
        </div>
      </div>
      <div className="image-cropper__footer">
        <div className='image-cropper__footer__left'>
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            onClick={chooseImage}
          >
            Change
          </Button>

          {
            !imageLoader &&
            <Button
              variant="outlined"
              color="error"
              size="medium"
              sx={{ ml: 1.25 }}
              onClick={deleteImage}
            >
              Delete
            </Button>
          }
        </div>
        <div className='image-cropper__footer__right'>
          {
            !imageLoader &&
            <LoadingButton
              variant="contained"
              color="primary"
              size="medium"
              sx={{ mr: 1.25 }}
              onClick={handleSave}
              loading={saveButtonLoading}
            >
              Save
            </LoadingButton>
          }
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            onClick={cancel}
          >
            Cancel
          </Button>
        </div>
      </div>
    </>
  );
}

export default ImageCropper;